import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap, take } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { AuthService } from '../services/auth.service';

export const bearerInterceptor: HttpInterceptorFn = (req : HttpRequest<unknown>, next) => {
  /// **NOTE** Protects against https://a.b/c/{apiDomain}?d={apiDomain}
  const url = new URL(req.url);
  if (!url.hostname.endsWith(environment.apiDomain)) {
    return next(req);
  }

  return inject(AuthService)
    .getIdToken()
    .pipe(
      take(1),
      switchMap((token) =>
        next(token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req),
      ),
    );
};
